import { Array } from "../array";
import { Constructor } from "./classes";
import { InterfaceRef } from "./interfaces";
import type { TypeFor, TypeRef, TypeRefFor } from "./types";


export interface ArrayTypeRef<T = any> extends Constructor<T[]>
{
    itemType: TypeRefFor<T>;
}

export namespace ArrayTypeRef
{
    export function get<T>(itemType: InterfaceRef<T>): ArrayTypeRef<T>;
    // export function get<T extends Enum<string | number>>(itemType: EnumRef): ArrayTypeRef<T>;
    export function get<T extends TypeRef>(itemType: T): ArrayTypeRef<TypeFor<T>>;
    export function get(itemType: TypeRef): ArrayTypeRef
    {
        let arrayType = arrayTypes.get(itemType);
        if (arrayType)
            return arrayType;

        arrayType =
            class extends Array<any>
            {
                static itemType = itemType;
            };

        const typeName = `Array<${itemType.name}>`;
        Object.defineProperty(arrayType, "name", { value: typeName, writable: false });

        arrayTypes.set(itemType, arrayType);

        return arrayType;
    }

    export function isArrayTypeRef(value: unknown): value is ArrayTypeRef
    {
        if (!value)
            return false;
        return value == Array || Object.getPrototypeOf(value) == Array;
    }


    const arrayTypes = new Map<TypeRef, ArrayTypeRef>();
}


export const isArrayTypeRef = ArrayTypeRef.isArrayTypeRef;


export const ArrayOf = ArrayTypeRef.get;
